import { StandardEvents } from '@shopify/events';

function normalizeCartItem(item, quantity = item?.quantity) {
  if (!item) return null;

  const priceInCents = Number(item.final_price ?? item.discounted_price ?? item.price);
  const normalizedPrice = Number.isFinite(priceInCents) ? priceInCents / 100 : null;

  return {
    item_id: item.sku || item.variant_id || item.id || null,
    shopify_product_id: item.product_id || null,
    shopify_variant_id: item.variant_id || item.id || null,
    item_name: item.product_title || item.title || null,
    item_brand: item.vendor || 'Bless Home',
    item_category: item.product_type || null,
    price: normalizedPrice,
    quantity: Number(quantity || 1),
  };
}

document.addEventListener(StandardEvents.productSelect, (event) => {
  event.promise
    ?.then(({ detail }) => {
      const variant = detail?.resource;
      if (!variant) return;

      document.dispatchEvent(
        new CustomEvent('bh:variant-change', {
          detail: {
            id: variant.id,
            sku: variant.sku || null,
            price: variant.price,
            available: variant.available !== false,
          },
        })
      );
    })
    .catch(() => {});
});

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise
    ?.then(({ detail }) => {
      if (detail?.didError) return;

      const lines = Array.isArray(event.lines) ? event.lines : [];
      const cartItems = Array.isArray(detail?.items) ? detail.items : [];

      const normalizedCartItems = cartItems.map((item) => normalizeCartItem(item)).filter(Boolean);
      const cartValue = normalizedCartItems.reduce((total, item) => {
        const lineValue = Number(item.price) * Number(item.quantity);
        return total + (Number.isFinite(lineValue) ? lineValue : 0);
      }, 0);

      document.dispatchEvent(
        new CustomEvent('bh:cart-state', {
          detail: {
            value: cartValue,
            items: normalizedCartItems,
          },
        })
      );

      if (detail?.source !== 'product-form-component') return;

      const firstLine = lines[0] || {};
      const addedItems = lines
        .map((line) => {
          const cartItem = cartItems.find((item) => {
            const variantId = item?.variant_id || item?.id;
            return String(variantId) === String(line.merchandiseId);
          });
          const item = normalizeCartItem(cartItem, line.quantity);
          if (!item) return null;

          item.shopify_product_id = item.shopify_product_id || detail.productId || null;
          return item;
        })
        .filter(Boolean);
      const firstItem = addedItems[0] || null;

      document.dispatchEvent(
        new CustomEvent('bh:cart-add-success', {
          detail: {
            variantId: firstLine.merchandiseId || null,
            quantity: Number(firstLine.quantity || detail.itemCount || 1),
            productId: detail.productId || firstItem?.shopify_product_id || null,
            sku: firstItem?.item_id || null,
            name: firstItem?.item_name || null,
            brand: firstItem?.item_brand || null,
            category: firstItem?.item_category || null,
            price: firstItem?.price ?? null,
            items: addedItems,
          },
        })
      );
    })
    .catch(() => {
      // Failed cart requests are intentionally not reported as successful additions.
    });
});
